import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { DxModalButton } from "./dx-modal-button";
/** Опции модального окна. */
let DxModalOptions = class DxModalOptions {
    /** Опции модального окна. */
    constructor() {
        /** Показывать \ не крестик в шапке модалки. */
        this._showCrossBtn = true;
        /** Закрывать \ не закрывать модаку при клике вне ее. */
        this._closeOnBackgroundClick = false;
        /**
         * Размер модального окна.
         * Допустимые значения: `"mini" | "tiny" | "small" | "normal" | "large"`.
         */
        this._size = 'small';
        this._buttons = [];
    }
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    get showCrossBtn() {
        return this._showCrossBtn;
    }
    set showCrossBtn(value) {
        this._showCrossBtn = value;
    }
    get closeOnBackgroundClick() {
        return this._closeOnBackgroundClick;
    }
    set closeOnBackgroundClick(value) {
        this._closeOnBackgroundClick = value;
    }
    get size() {
        return this._size;
    }
    set size(value) {
        this._size = value;
    }
    get bodyIcon() {
        return this._bodyIcon;
    }
    set bodyIcon(value) {
        this._bodyIcon = value;
    }
    get buttons() {
        return this._buttons;
    }
    set buttons(value) {
        this._buttons = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "title", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxModalOptions.prototype, "_title", void 0);
tslib_1.__decorate([
    jsonMember({ name: "showCrossBtn", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxModalOptions.prototype, "_showCrossBtn", void 0);
tslib_1.__decorate([
    jsonMember({ name: "closeOnBackgroundClick", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxModalOptions.prototype, "_closeOnBackgroundClick", void 0);
tslib_1.__decorate([
    jsonMember({ name: "bodyIcon", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxModalOptions.prototype, "_bodyIcon", void 0);
tslib_1.__decorate([
    jsonMember({ name: "size", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxModalOptions.prototype, "_size", void 0);
tslib_1.__decorate([
    jsonArrayMember(DxModalButton, { name: "buttons", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], DxModalOptions.prototype, "_buttons", void 0);
DxModalOptions = tslib_1.__decorate([
    jsonObject
], DxModalOptions);
export { DxModalOptions };
